"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iapetus = void 0;
const Colony_1 = require("../../../colonies/Colony");
const ColonyName_1 = require("../../../colonies/ColonyName");
const ColonyBenefit_1 = require("../../../colonies/ColonyBenefit");
class Iapetus extends Colony_1.Colony {
    constructor() {
        super(...arguments);
        this.name = ColonyName_1.ColonyName.IAPETUS;
        this.description = 'TR';
        this.buildType = ColonyBenefit_1.ColonyBenefit.GAIN_TR;
        this.tradeType = ColonyBenefit_1.ColonyBenefit.GAIN_TR;
        this.tradeQuantity = [0, 0, 0, 1, 1, 1, 2];
        this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_CARD_DISCOUNT;
        this.details = [
            'Gain 1 TR',
            'Gain n TR',
            'Playing cards costs 1 M€\nless this generation',
        ];
    }
}
exports.Iapetus = Iapetus;
//# sourceMappingURL=Iapetus.js.map